import {Component, OnInit} from '@angular/core';
import {Observable, of as ObservableOf} from 'rxjs';
import {AppUtilService} from 'app/services/app-util.service';
import {environment} from '../../environments/environment';
import {Meta} from "@angular/platform-browser";
import {ScriptService} from "@summit/nav";
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {AuthenticationService} from "../services/authentication.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrls: ['./app.scss']
})
export class AppComponent implements OnInit {
  public imagesURL: string;
  public alertsServices: string;
  public restfulServices: string;
  public isProduction: boolean;
  public appProgrammaticName: string;

  constructor(
    private appUtil: AppUtilService,
    private meta: Meta,
    private scriptService: ScriptService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService
  ) {
    this.imagesURL = environment.imagesURL;
    this.alertsServices = environment.alertsServices;
    this.restfulServices = environment.restfulServices;
    this.isProduction = environment.production;
    this.appProgrammaticName = environment.appProgrammaticName;
  }

  public ngOnInit() {
    /**
     * This code adds specific meta tags given the app is on some kind of test environment.
     * All off the NonTestServers are listed in the ScriptService if you need to add or modify at some point.
     */
    const SERVER_NAME = this.scriptService.getServerName(true);

    if (!this.scriptService.getNonTestServers().includes(SERVER_NAME)) {

      // Test CSP should be stored as a string in the environment variables
      // this.meta.addTag({httpEquiv: 'Content-Security-Policy', content: environment.csp});

      // This prevents tracking on test servers
      this.meta.addTag({name: 'robots', content: 'noindex,nofollow'});
    }
    /** ------------------------------------------------------------------ **/

    /**
     * This gets certain query params on load that may be required by the chatbot to autolaunch if needed.
     * It will then store that value in the service for initialization at a later time.
     */
    this.router.events
      .subscribe(ev => {
        if (ev instanceof NavigationEnd) {
          const query = this.route.snapshot.queryParamMap;
          if (query.has('source')) {
            this.authService.autoLaunchChatbot = query.get('source');
          }
        }
      })
    /** ------------------------------------------------------------------ **/

  }

  public getTitle(): Observable<string> {
    return ObservableOf(this.appUtil.getTitle());
  }
}
